import { faPencil } from '@fortawesome/pro-regular-svg-icons';
import React from 'react';
import { Avatar } from 'src/components/Avatar';
import { Box } from 'src/components/Box';
import { Chip } from 'src/components/Chip';
import { Icon } from 'src/components/Icon';
import { Stack } from 'src/components/Stack';
import { Typography } from 'src/components/Typography';
import { SxProps } from 'src/components/muiTheme/utils';
import { Theme } from 'src/components/muiTheme/utils';
import { User } from 'src/models/user/_types';
import { getUserDisplayName, getUserInitials } from 'src/models/user/utils';

interface UserSelectorChipProps {
  user?: User;
  displayName?: string;
  profileImage?: string;
  initials?: string;
  avatarChildren?: React.ReactNode;
  onChangeUser: () => void;
  size?: 'small' | 'medium';
  sx?: SxProps<Theme>;
  endAdornment?: React.ReactNode;
  ariaLabel?: string;
}

export const UserSelectorChip: React.FC<UserSelectorChipProps> = ({
  user,
  displayName,
  profileImage,
  initials,
  avatarChildren,
  onChangeUser,
  size = 'medium',
  sx,
  endAdornment = (
    <>
      <Icon icon={faPencil} size="small" />
    </>
  ),
  ariaLabel,
}) => {
  const name = displayName ?? (user ? getUserDisplayName(user) : 'Guest');
  const avatarSrc = profileImage ?? user?.profileImage;
  const avatarInitials =
    initials ?? (avatarChildren ? undefined : user ? getUserInitials(user) : '');

  return (
    <Chip
      clickable
      onClick={onChangeUser}
      size={size}
      aria-label={ariaLabel}
      label={
        <Stack direction="row" alignItems="center" spacing={1}>
          <Avatar
            src={avatarSrc}
            initials={avatarInitials}
            size={size === 'small' ? 'xsmall' : 'small'}
          >
            {avatarChildren}
          </Avatar>
          <Box>
            <Typography variant="body2" fontWeight={600}>
              {name}
            </Typography>
          </Box>
          {endAdornment}
        </Stack>
      }
      sx={{
        pl: 0.5,
        pr: 1,
        mb: 1,
        height: 'auto',
        py: 0.5,
        '& .MuiChip-label': {
          px: 0,
        },
        ...sx,
      }}
    />
  );
};
